var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "15px",
    viewBox: "0 0 10 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IDEs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.539999962
  }, /*#__PURE__*/React.createElement("g", {
    id: "p5js-IDE-styles-foundation-pt-2",
    transform: "translate(-529.000000, -1165.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "arrow-shape-copy",
    transform: "translate(534.000000, 1172.198314) rotate(-90.000000) translate(-534.000000, -1172.198314) ",
    points: "535.4 1169.39663 541 1174.99663 539.6 1176.39663 534 1170.79663 528.4 1176.39663 527 1174.99663 532.6 1169.39663 533.996628 1168"
  })))));
};
export default SvgLeftArrow;